/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { SupplySchedule } from "./SupplySchedule";

export class SupplyScheduleFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<SupplySchedule> {
    return super.deploy(overrides || {}) as Promise<SupplySchedule>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SupplySchedule {
    return super.attach(address) as SupplySchedule;
  }
  connect(signer: Signer): SupplyScheduleFactory {
    return super.connect(signer) as SupplyScheduleFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SupplySchedule {
    return new Contract(address, _abi, signerOrProvider) as SupplySchedule;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decayRate",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inflationRate",
    outputs: [
      {
        internalType: "uint256",
        name: "d",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IMinter",
        name: "_minter",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_inflationRate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_decayRate",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_mintDuration",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isMintable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isStarted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mintableSupply",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextMintTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "recordMintEvent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "d",
            type: "uint256",
          },
        ],
        internalType: "struct Decimal.decimal",
        name: "_decayRate",
        type: "tuple",
      },
    ],
    name: "setDecayRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "startSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "supplyDecayEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
